/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const PageHeadingAboutMakerSection = ({
  title,
  subtitle,
  description,
  cta,
  images,
}) => {
  return (
    <Box
      bg="backgroundLight"
      pb={['138px', '188px', '172px', '186px']}
      pt={[5, 7, 9]}
      sx={{ overflow: 'hidden', position: 'relative' }}
    >
      <Container>
        <Heading
          as="h1"
          variant="title1"
          mb={[4, null, 11]}
          sx={{ textAlign: 'center' }}
        >
          {title}
        </Heading>
        <Grid columns={[null, 12]} sx={{ rowGap: '0', position: 'relative' }}>
          {images && images[0] && (
            <Box
              mx="auto"
              mb={[4, 3]}
              px={[null, null, null, 1]}
              sx={{
                gridColumn: [null, '4 / 10', '1 / 6'],
                width: ['288px', '100%'],
                zIndex: '1',
              }}
            >
              <GatsbyImage
                image={images[0].gatsbyImageData}
                alt={images[0].description}
                loading="eager"
              />
            </Box>
          )}

          <Box
            sx={{
              gridColumn: [null, '2 / 12', '6 / 12'],
              position: 'relative',
              '&:after': {
                backgroundImage: `url('/images/backgrounds/about-maker-blob.svg')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                bottom: ['-80px', '-130px'],
                content: '""',
                display: 'block',
                left: ['-460px', '-400px', null, '-430px'],
                position: 'absolute',
                top: ['-100px', null, '-30px'],
                width: '1386px',
              },
            }}
          >
            <Box
              mt={[null, null, 5, 6]}
              sx={{
                position: 'relative',
                zIndex: '1',
              }}
            >
              <Heading as="h2" variant="title3" mb={[2, 3]}>
                {subtitle}
              </Heading>
              <Box
                variant="text.body2"
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
                sx={{
                  '& p': {
                    m: 0,
                    mb: [2, 3],
                  },
                }}
              />
              <img
                src="/images/icons/maker-founders-signature.svg"
                alt="Sarah, Kendra, and Zoe"
              />
              {cta && <Box sx={{ mt: [2, 3] }}>{cta}</Box>}
            </Box>
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default PageHeadingAboutMakerSection
